import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";

import Button from "components/CustomButtons/Button.jsx";
import InputLabel from "@material-ui/core/InputLabel";
import TextField from "@material-ui/core/TextField";

class AddApplicationPageNoteDialog extends React.Component {

    constructor (props) {

        super(props);

        this.state = {
            "message": "",
        };
    }

    handleAddNote(event) {
        this.props.handleAddNote(this.props.selected_application_id, this.state.message, this.props.add_note_page);
    }

    componentWillReceiveProps(props) {
        if (props.addNote === false)
            this.setState({"message" : ""});
    }

  render () {
      const {classes} = this.props;
      return (
          <Dialog
              aria-describedby="update-profile-confirm-modal-slide-description"
              aria-labelledby="small-modal-slide-title"
              classes={{
                  "root": `${classes.center} ${classes.modalRoot}`,
                  "paper": `${classes.modal} ${classes.modalSmall}`
              }}
              fullWidth
              keepMounted
              onClose={() => {this.setState({"additional_fields_values": [], "message": ""}); this.props.onClose("addNote");}}
              open={this.props.addNote}
          >
              <DialogTitle
                  className={`${classes.modalBody} ${classes.modalSmallBody}`}
                  style={{"paddingBottom": "0px"}}
              >
                  Add Note
              </DialogTitle>
              <DialogContent
                  className={`${classes.modalBody} ${classes.modalSmallBody}`}
                  id="update-profile-confirm-modal-slide-description"
              >
                <InputLabel
                    style={{ paddingTop : "1.5rem" }}
                    className={classes.selectLabel}
                    htmlFor="message"
                >
                    Message
                </InputLabel>
                <TextField
                    inputProps={{
                        name: `message`,
                        id: `message`
                    }}
                    type="text"
                    className="w-100"
                    value={this.state.message ? this.state.message : ""}
                    multiline={true}
                    rows={3}
                    onChange={(event) => this.setState({"message": event.target.value})}
                />
              </DialogContent>
              <DialogActions
                  className={`${classes.modalFooter} ${classes.modalFooterCenter}`}
              >
                <Button
                    className={classes.modalSmallFooterFirstButton}
                    color="transparent"
                    onClick={() => {this.setState({"additional_fields_values": [], "message": ""}); this.props.onClose("addNote");}}
                >
                    Close
                </Button>
                <Button
                    className={`${classes.modalSmallFooterFirstButton} ${classes.modalSmallFooterSecondButton}`}
                    color="success"
                    disabled={this.state.btnDisabled}
                    onClick={(event) => this.handleAddNote(event)}
                    simple
                    >
                    Save
                </Button>
              </DialogActions>
          </Dialog>
      );
  }
}

export default withStyles(extendedFormsStyle)(AddApplicationPageNoteDialog);
